import { render, staticRenderFns } from "./PolarityPie.vue?vue&type=template&id=e3b6564c"
import script from "./PolarityPie.vue?vue&type=script&lang=js"
export * from "./PolarityPie.vue?vue&type=script&lang=js"
import style0 from "./PolarityPie.vue?vue&type=style&index=0&id=e3b6564c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports